export type DateObject = { day: string; month: string; year: number; hour: string, minutes: string, seconds: string }

export const dateToObject = (date: Date): DateObject => {
    return {
        day: String(date.getDate()).padStart(2, '0'),
        month: String(date.getMonth() + 1).padStart(2, '0'),
        year: date.getFullYear(),
        hour: String(date.getHours()).padStart(2, '0'),
        minutes: String(date.getMinutes()).padStart(2, '0'),
        seconds: '00'
    }
}

export const convertTimeColon = (time: string): string => {
    const possibleMatch = time.match(/(^\d{2}:\d{2})/) // 12:00:00
    return time && possibleMatch?.length ? possibleMatch[0] : '' // 12:00 or ''
}

export const convertTimeAllNumbers = (time: string): string => {
    const possibleMatch = time.match(/.{1,2}/g) //120000
    return possibleMatch?.length && possibleMatch.length < 4 ? `${possibleMatch[0]}:${possibleMatch[1]}` : '' // 12:00 or ''
}

export const convertDateAllNumbers = (date: string): string => {
    const possibleMatch = date.match(/.{1,2}/g) //202110127
    return possibleMatch && possibleMatch.length < 5
        ? `${possibleMatch[0]}${possibleMatch[1]}/${possibleMatch[2]}/${possibleMatch[3]}` //2021/01/27
        : ''
}

export const getToday = (): DateObject => {
    const todaysDate = new Date()
    return dateToObject(todaysDate)
}

export const getTomorrow = (): DateObject => {
    const tomorrowsDate = new Date()
    tomorrowsDate.setDate(tomorrowsDate.getDate() + 1)
    return  dateToObject(tomorrowsDate)
}

// This is used to give the customer a 15 min buffer to complete their return
export const getCurrentDateTimePlus15Mins = (): Date => {
    const currentDateTime: Date = new Date()
    currentDateTime.setMinutes(currentDateTime.getMinutes() + 15)
    return currentDateTime;
} 

export const createDayOfWeek = (day: (string | number), messages: (any)): string => {
    let dayOfWeek;
            switch (day) {
                case 1:
                    dayOfWeek = messages.createCollection.timeSlot.monday()
                    break;
                case 2:
                    dayOfWeek = messages.createCollection.timeSlot.tuesday()
                    break;
                case 3:
                    dayOfWeek = messages.createCollection.timeSlot.wednesday()
                    break;
                case 4:
                    dayOfWeek = messages.createCollection.timeSlot.thursday()
                    break;
                case 5:
                    dayOfWeek = messages.createCollection.timeSlot.friday()
                    break;
                case 6:
                    dayOfWeek = messages.createCollection.timeSlot.saturday()
                    break;
                case 0:
                    dayOfWeek = messages.createCollection.timeSlot.sunday()
                    break;
            }
            return dayOfWeek
}

// This check is needed to prevent "Today" to be wrongly shown, instead of the following day, 
// in the last 15min of the day, because previously we've added a 15 min buffer to the current date, 
// in the getCurrentDateTimePlus15Mins function, to allow the user to complete the return
const isLast15MinutesOfDay = () => {
  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  return hours === 23 && minutes >= 45;
};

export const getDayOfWeek = (plannedDate: (string | number), currentDate: (string | number), day: (string | number), messages: (any)): string => {
    if (plannedDate === currentDate && !isLast15MinutesOfDay()) {
            return messages.createCollection.timeSlot.today()
        } else {
            return createDayOfWeek(day, messages)
        }
}